import Ticket from "../../public/custom-icons/detail-custom/ticket.svg";
import GeoTag from "../../public/custom-icons/detail-custom/geotag.svg";
import Keys from "../../public/custom-icons/detail-custom/keys.svg";
import English from "../../public/custom-icons/detail-custom/english-flag.svg";
import Spanish from "../../public/custom-icons/detail-custom/spanish-flag.svg";
import French from "../../public/custom-icons/detail-custom/french-flag.svg";
import Italian from "../../public/custom-icons/detail-custom/italian-flag.svg";
import Pointer from "../../public/custom-icons/detail-custom/pointer.svg";

const packageDetailCustomSvg = {
    Ticket,
    GeoTag,
    Keys,
    English,
    Spanish,
    French,
    Pointer,
    Italian,
};

export default packageDetailCustomSvg;
